module.exports = __webpack_public_path__ + "static/media/Zineflex.e6040978.webp";